import { createTranslations } from '@npco/utils-translations'

export const translations = createTranslations({
  title: "You don't have any Settlements yet",
  description:
    'Card payments will be settled daily to your nominated account and listed here.',
})
